import React from 'react'
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

type Props = {
    type?       : 'v1' | 'v2'
    hint        : string

    className?  : string
}

export default function HelpButton(props:Props) {

    const classes = Classes("ui5-ico-help", props.className, {
        'v1': !props.type || props.type === 'v1',
        'v2': props.type === 'v2'
    })

    return (
        <div className={classes}>
            <HintPopover
                hint        = {props.hint}
                multiline   = {true}
            />
        </div>
    )
}